import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ADMIN_TOKEN_EXPIRED, BASE_ROUTE } from 'utilities/routes';
import NetworkRequiredRoutes from 'components/networkRequiredRoutes';
import Layout from '../pages/NewAdmin/Layout';
import NewAdminSetup from '../pages/NewAdmin';
import ExpiredToken from '../pages/NewAdmin/ExpiredToken';

const NewAdminRoutes = () => {
  return (
    <NetworkRequiredRoutes>
      <Routes>
        <Route path={BASE_ROUTE} element={<Layout />}>
          <Route path={BASE_ROUTE} element={<NewAdminSetup />} />
          <Route path={ADMIN_TOKEN_EXPIRED} element={<ExpiredToken />} />
        </Route>
      </Routes>
    </NetworkRequiredRoutes>
  );
};

export default NewAdminRoutes;
